import { useState } from 'react';
import { Platform, View } from 'react-native';
import { useUIStore } from '@/store';

// A message is a text-selection surface, not a button. Raw macOS View mouse
// events reveal controls without a nested Pressable claiming its responder.
const MessageContainer = View;

// Touch devices always expose actions. Only Mac messages need hover reveal.
export default function useNativeMessageActions() {
  const [isHovered, setIsHovered] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const alwaysShow = useUIStore(state => state.showMessageActions === true);
  const isMac = Platform.OS === 'macos';
  return {
    MessageContainer,
    actionsVisible: !isMac || alwaysShow || isHovered || isFocused,
    hoverProps: isMac ? {
      onMouseEnter: () => setIsHovered(true),
      onMouseLeave: () => setIsHovered(false),
      onFocus: () => setIsFocused(true),
      onBlur: () => setIsFocused(false),
    } : {},
  };
}
